import React from 'react';

import { hasExclusion } from './ExclusionMatrix';
import { RateValue } from './RateValue';
import { RoleLevelMatrices } from './RoleLevelMatrices';
import { RoleLevelMatrix } from './RoleLevelMatrix';

export const RateValueMatrices = ({
  structures,
  roles,
  isLoaded,
  exclusions,
  getValue,
  onCellClick,
}) => (
  <RoleLevelMatrices
    structures={structures}
    roles={roles}
    isLoaded={isLoaded}
    emptyText="No roles have been added to this lot"
    renderMatrix={(group) => (
      <RoleLevelMatrix
        {...group}
        label={`Rates for ${group.structure.name}`}
        showDescriptions
        renderCell={(role, level) => (
          <RateValue
            value={getValue(role.role_id, level.level_id)}
            excluded={hasExclusion(exclusions, role.role_id, level.level_id)}
            label={`Rates ${role.name} ${level.name}`}
            onClick={onCellClick && (() => onCellClick(role, level))}
          />
        )}
      />
    )}
  />
);
